import React, { useEffect, useState } from "react";
import { Box, Grid, Typography } from "@mui/material";
import { CityOverviewType } from "../../types/record";
import CircleProgress from "./CircleProgress";
import { SPColor } from "../../constants/color";
import ClockIcon from "../../assets/images/clock.png";
import ClassIcon from "../../assets/images/class.png";
import StudentsIcon from "../../assets/images/students.png";
import SchoolIcon from "../../assets/images/school.png";

import ShearimLogo from "../../assets/images/shearim.png";
import IvritimeLogo from "../../assets/images/ivritime_app_icon.png";

type CityOverviewProps = {
  cityOverview: CityOverviewType | null;
  tiktokUrl: string;

  homeIframeUrl: string;
};

export default function CityOverview({
  cityOverview,
  tiktokUrl,
  homeIframeUrl,
}: CityOverviewProps) {
  if (!cityOverview) {
    return null;
  }

  return (
    <Box>
      <Grid container>
        <Grid item md={3} xs={6}>
          <CircleProgress
            value={cityOverview["speaking-hours"]}
            text="שעות דיבור"
            color={SPColor.YELLOW}
            icon={<img src={ClockIcon} alt="clock" width={"100%"} />}
            bottomBadge={
              <Box sx={{ fontSize: "1rem", fontWeight: 500 }}>
                <Typography fontWeight={"bold"}>שבוע שעבר </Typography>
                <Typography fontWeight={"bold"}>
                  {cityOverview["last-week-speaking-hours"] || 0}
                </Typography>
              </Box>
            }
          />
        </Grid>

        <Grid item md={3} xs={6}>
          <CircleProgress
            value={cityOverview["students"]}
            text="תלמידים"
            color={SPColor.ORANGE}
            icon={<img src={StudentsIcon} alt="clock" width={"100%"} />}
            bottomBadge={
              <Box sx={{ fontSize: "1rem", fontWeight: 500 }}>
                <Typography fontWeight={"bold"}>פעילים </Typography>
                <Typography fontWeight={"bold"}>
                  {cityOverview["active-students"] || 0}
                </Typography>
              </Box>
            }
          />
        </Grid>
        <Grid item md={3} xs={6}>
          <CircleProgress
            value={cityOverview["classes"]}
            text="כיתות"
            color={SPColor.GREEN}
            icon={<img src={ClassIcon} alt="clock" width={"100%"} />}
          />
        </Grid>
        <Grid item md={3} xs={6}>
          <CircleProgress
            value={cityOverview["schools"]}
            text="בתי ספר"
            color={SPColor.BLUE}
            icon={<img src={SchoolIcon} alt="clock" width={"100%"} />}
          />
        </Grid>
      </Grid>
      <Box mt={4}>
        <iframe
          src={homeIframeUrl}
          style={{ width: "100%", minHeight: "80vh", border: "none" }}
        />
      </Box>
    </Box>
  );

  if (!cityOverview) {
    return null;
  }

  // return (
  //   <Box>
  //     <Grid container>
  //       <Grid item md={3} xs={6}>
  //         <CircleProgress
  //           value={cityOverview["speaking-hours"]}
  //           text="שעות דיבור"
  //           color={SPColor.YELLOW}
  //           icon={<img src={ClockIcon} alt="clock" width={"100%"} />}
  //           bottomBadge={
  //             <Box sx={{ fontSize: "1rem", fontWeight: 500 }}>
  //               <Typography fontWeight={"bold"}>שבוע שעבר </Typography>
  //               <Typography fontWeight={"bold"}>
  //                 {cityOverview["last-week-speaking-hours"] || 0}
  //               </Typography>
  //             </Box>
  //           }
  //         />
  //       </Grid>

  //       <Grid item md={3} xs={6}>
  //         <CircleProgress
  //           value={cityOverview["students"]}
  //           text="תלמידים"
  //           color={SPColor.ORANGE}
  //           icon={<img src={StudentsIcon} alt="clock" width={"100%"} />}
  //           bottomBadge={
  //             <Box sx={{ fontSize: "1rem", fontWeight: 500 }}>
  //               <Typography fontWeight={"bold"}>פעילים </Typography>
  //               <Typography fontWeight={"bold"}>
  //                 {cityOverview["active-students"] || 0}
  //               </Typography>
  //             </Box>
  //           }
  //         />
  //       </Grid>
  //       <Grid item md={3} xs={6}>
  //         <CircleProgress
  //           value={cityOverview["classes"]}
  //           text="כיתות"
  //           color={SPColor.GREEN}
  //           icon={<img src={ClassIcon} alt="clock" width={"100%"} />}
  //         />
  //       </Grid>
  //       <Grid item md={3} xs={6}>
  //         <CircleProgress
  //           value={cityOverview["schools"]}
  //           text="בתי ספר"
  //           color={SPColor.BLUE}
  //           icon={<img src={SchoolIcon} alt="clock" width={"100%"} />}
  //         />
  //       </Grid>
  //     </Grid>
  //     <Box
  //       sx={{
  //         direction: "RTL",
  //         marginTop: 6,
  //         marginRight: 6,
  //         marginLeft: 6,
  //         textAlign: "justify",
  //       }}
  //     >
  //       <Typography>
  //         עברית דבורה היא מיומנות נדרשת להתקדמות בחיים בישראל בעבודה, בלימודים,
  //         ובכל תחום אחר. במטרה לקדם את העברית הדבורה בקרב תלמידים בדואים בנגב,
  //         עמותת בודור השיקה פרויקט נרחב בנגב. במסגרת הפרויקט משולבת סביבת לימוד
  //         דיגיטלית, ותחרות בין בתי הספר ובכיתות על כמות התרגול. הפרויקט מבוצע
  //         בשיתוף פעולה עם חברות ספיקינגפאל SpeakingPal ו AAP הישראליות. הפרוייקט
  //         יקדם את התחומים הבאים:{" "}
  //       </Typography>
  //       <Typography>
  //         <ul>
  //           <li>דגש על השפה העברית הדבורה</li>
  //           <li>אימון דיבור עם קבלת פידבק שוטף, תיקון ושיפור</li>
  //           <li>
  //             שילוב מיטבי בין מספר מיומנויות השפה - אוצר מילים, הגייה, דקדוק,
  //             ניהול שיח והבנת הנשמע והנקרא
  //           </li>
  //           <li>תרגול מול שחקנים ושחקניות</li>
  //           <li>לוח בקרה וניהול הלמידה למורים</li>
  //         </ul>
  //       </Typography>
  //       <Typography marginTop={2}>
  //         התוכנית מבוססת על התוכנית ללימוד אנגלית דבורה של SpeakingPal שזכתה
  //         בפרסים רבים בארץ ובעולם.
  //       </Typography>
  //       <Typography marginTop={2}>
  //         מי אנחנו: אפליקציה מתקדמת ללימוד ותרגול עברית דבורה עבור דוברי ערבית /
  //         אנגלית, פרי פיתוח של חברת
  //         <br />
  //         SpeakingPal המתמחה בטכנולוגיות ללמידת שפה וחברת AAP המתמחה בהוראת שפה
  //         ותרבות.
  //         <br />
  //         האפליקציה מבוססת על שילוב בין טכנולוגיה מתקדמת של זיהוי דיבור ובין
  //         מומחיות תוכן ופדגוגיה בתחום הוראת העברית כשפה שניה / זרה.
  //         <br />
  //         האפליקציה בנויה מיחידות לימוד בנושאים שימושיים שונים ומשלבת בין מגוון
  //         כשירויות לשוניות ופעילויות שפה, תוך התמקדות בהפקה דבורה ובאינטראקציה
  //         דבורה (מותאמת גישת CEFR).
  //         <br />
  //         האפליקציה בשלב זה כוללת 6 יחידות לימוד ברמת שפה בסיסית - בינונית
  //         ועוסקת בנושאי יומיום האופייניים לסיטואציות של הצגה עצמית, שיחת היכרות
  //         ושיחות בין חברים. תרגול מיטבי של כל אחת מיחידות הלימוד לימוד יכול
  //         להתפרס על פני חודש לימודים בבית הספר ואף יותר מכך.
  //       </Typography>
  //       <Typography marginTop={2}>
  //         פרטים נוספים על סביבת הלימוד של SpeakingPal באתר החברה:
  //       </Typography>
  //       <a
  //         href="https://www.speakingpal.com/moe-program/moe.html"
  //         target="_blank"
  //         rel="noreferrer"
  //       >
  //         <Typography marginTop={2}>
  //           https://www.speakingpal.com/moe-program/moe.html
  //         </Typography>
  //       </a>
  //     </Box>
  //     <Box
  //       sx={{
  //         display: "flex", // Use flex for all screen sizes
  //         flexDirection: "row", // Ensure direction is row
  //         justifyContent: "space-between", // Distribute space between images
  //         alignItems: "center", // Align items vertically centered
  //         width: "80%", // Adjust width as needed
  //         maxWidth: "600px", // Optional: Set a max width for better control
  //         margin: "auto", // Center the Box horizontally
  //         marginTop: 3, // Add top margin
  //         gap: 2, // Optional: Add gap between images
  //         flexWrap: "wrap", // Optional: Allow wrapping on very small screens
  //       }}
  //     >
  //       <img src={ShearimLogo} alt="ShearimLogo" height="100" />
  //       <img src={IvritimeLogo} alt="IvritimeLogo" height="100" />
  //     </Box>
  //   </Box>
  // );
}
